import {Survey} from "../../models/survey";
import {AppAction} from "../../root/AppAction";
import SurveyEvents from "../events/SurveyEvents";

// 定義
export interface SurveyStore {
    // ビデオごとのアンケート
    SurveyList: Survey[];
    // 全アンケート
    allSurveyList: Survey[];
    isLoading: boolean;
    isUpdatingSurveyList: boolean;
    isSuccessUpdateSurveyList: boolean;
    isFailedUpdateSurveyList: boolean;
    errorMessage: string;
}

// 初期値
const initialStore:
SurveyStore = {
    SurveyList: [],
    allSurveyList: [],
    isLoading: false,
    isUpdatingSurveyList: false,
    isSuccessUpdateSurveyList: false,
    isFailedUpdateSurveyList: false,
    errorMessage: ""
};

// 実行
export default function SurveyList(state: SurveyStore = initialStore, action: AppAction) {
    switch (action.type) {
        // アンケート情報取得
        case SurveyEvents.LoadSurveyByIdStarted:
            return {
                ...state,
                isLoading: true
           };
        case SurveyEvents.LoadSurveyByIdComplete:
            return {
                ...state,
                SurveyList: action.surveys,
                isLoading: false,
                errorMessage: ""
           };
        // アンケート回答登録
        case SurveyEvents.AddSurveyAnswerStarted:
            return {
                ...state
           };
        case SurveyEvents.AddSurveyAnswerComplete:
            return {
                ...state,
                SurveyList: action.surveys,
                errorMessage: ""
           };
        case SurveyEvents.AddSurveyAnswerFailed:
            return {
                ...state,
                errorMessage: action.error
           };

        // 全アンケート情報取得
        case SurveyEvents.GetAllSurveyStarted:
            return {
                ...state,
                isLoading: true
           };
        case SurveyEvents.GetAllSurveyComplete:
            return {
                ...state,
                allSurveyList: action.allSurvey,
                isLoading: false,
                errorMessage: ""
           };

        // アンケート新規追加
        case SurveyEvents.AddSurveyStarted:
            return {
                ...state,
                isLoading: true
           };
        case SurveyEvents.AddSurveyComplete:
            return {
                ...state,
                allSurveyList: [
                    ...state.allSurveyList,
                    action.newSurvey
                ],
                isLoading: false,
                errorMessage: ""
           };

        // アンケート更新
        case SurveyEvents.UpdateSurveyStarted:
            return {
                ...state,
                isLoading: true,
                isUpdatingSurveyList: true,
                isSuccessUpdateSurveyList: false,
                isFailedUpdateSurveyList: false
           };
        case SurveyEvents.UpdateSurveyComplete:
            return {
                ...state,
                allSurveyList: action.surveys,
                isLoading: false,
                isUpdatingSurveyList: false,
                isSuccessUpdateSurveyList: true,
                errorMessage: ""
           };
        case SurveyEvents.UpdateSurveyFailed:
            return {
                ...state,
                isLoading: false,
                isUpdatingSurveyList: false,
                isFailedUpdateSurveyList: true
           };
        default:
            return state;
   }
}
